import { StatsigClient } from "@statsig/js-client";
import { isStaging } from "./environment";

const STATSIG_CLIENT_KEY = import.meta.env.VITE_STATSIG_CLIENT_KEY || "";

export const statsigClient = new StatsigClient(
  STATSIG_CLIENT_KEY,
  { userID: "" },
  {
    environment: { tier: isStaging ? "staging" : "production" },
  }
);

export const initStatsig = async (user?: {
  id: number | string;
  email?: string;
}) => {
  if (user?.id) {
    await statsigClient.updateUserAsync({
      userID: String(user.id),
      email: user.email,
    });
  } else {
    await statsigClient.initializeAsync();
  }
};
